import React, { Component } from "react"
import { familyStatus, noYes, one2five, one2sixTEXT, onlyYes, one2sevenB } from '../../variables/ComboValues'
import { RadioSelect } from '../../elements/RadioSelect/RadioSelect'
import { updateElement } from "../Tree/Utils.js"
import { InputF, TextareaF, SelectF } from '../../elements/FormFields'
import { CalendarDay2 } from '../../elements/DayPicker/DayPicker2'

//import { on } from "cluster";


const  microLegend = {
  "id": "מספר השאלון",
  "interviewer": "מראיין",
  "date": "תאריך מילוי השאלון",
  "family_status": "סטטוס המשפחה",
  "q1": "מענים בתחום הכלכלי",
  "q7": "מענים בתחום התעסוקתי",
  "q8": "מענים בתחום המשפחתי",
  "q5": "מלווה משפחות",
  "q6": "השילוב (אינטגרציה) ביניהם",
  "q2": "באיזו מידה השגתם מה שרציתם?",
  "q17": "הסבר במילים",
  "q27": "הסבר במילים",
  "q37": "הסבר במילים",

 
  "q28": "באיזו מידה אתה שבע רצון מהסיוע של התכנית בנושא התעסוקה שלך?",
  
  "q34": "האם בשלשת החודשים האחרונים יש איזון בין ההכנסות וההוצאות שלכם?",
  
  "q30": "תעסוקת האשה",
  "q31": "תעסוקת הגבר",
  "q32": "התנהלות כלכלית משפחתית",
  "q33": "צמצום והסדר חובות",
  
  "q35": "תנאי דיור",
  "q36": "מימוש הזכויות שלכם בתחומים שונים",
  "q38": "סיוע משפטי",
  "q39": "העצמה ופיתוח אישי",
  "q40": "שיפור יחסים זוגיים",
  "q41": "טיפולים שנדרשו לילדים",
  "q42": "עזרה בתחום החינוך לילדים",
  "q43": "העשרה לילדים",
  
  "q44": "באיזו מידה אתם מרגישים שאם תצטרכו תוכלו להשיג את הזכויות שלכם בעצמכם?",
  "q451": "מצב כלכלי",
  "q452": "סיוע במעונות יום",
  "q453": "סלי מזון",
  "q454": "חוק נוער",
  "q455": "אלימות במשפחה",
  "q46": "צריכת שירותים",
  "q461": "מתנ''ס עבור הילדים",
  "q462": "לשכת הרווחה",
  "q463": "מעון יום",
  "q464": "תחנה לבריאות הציבור / טיפת חלב",
  "q465": "ארגוני חסד",
  "q466": "עזרה של עמותות (כגון, ידיד, יד שרה)",
  "q467": "מרכז לילד ולמשפחה",
  "q468": "עזרה בלימודים לילדים (כגון, חונך, מועדונית, מרכז למידה)",
  "q469": "התחנה לבריאות הנפש",
  "q4610": "קופת חולים",
  "q4611": "פעילויות העשרה לעצמכם",
  "q4612": "אחר",
  "q47": "האם מאז ההשתתפות בתכנית אתם יכולים להרשות לעצמכם טיפולים רפואיים שבעבר לא ביצעתם?",
  "q48": "האם מאז ההשתתפות בתכנית אתם יכולים להרשות לעצמכם הוצאות שבעבר לא ביצעתם?",
  "q49": "רשת תמיכה והתמודדות עם אתגרים", // Title only skip
  "q50": "בחר ציון",
  "q51": "באיזו מידה להרגשתכם עזרה לכם התכנית להתמודד עם האתגרים שעמדו בפניכם, מבחינה משפחתית ואישית?",
  "q52": "הסבר מילולי",
  "q53": "שאיפות וחלומות",
  "q54": "אשה: מה החלום שלך כיום?",
  "q55": "אשה: מה לדעתך יעזור לך להגשים אותו?",
  "q561": "גורמים פנימיים: החלטיות / עקביות / מחויבות",
  "q562": "רכישת כלים ומיומנויות נוספים",
  "q563": "הסכמה ותמיכה הדדית בין בני הזוג",
  "q564": "עזרה מגורם חיצוני",
  "q565": "גורל / מזל",
  "q566": "נסיבות חיצוניות",
  "q567": "אחר",
  "q57": "גבר: מה החלום שלך כיום?",
  "q58": "גבר: מה לדעתך יעזור לך להגשים אותו?",
  "q591": "גורמים פנימיים: החלטיות / עקביות / מחויבות",
  "q592": "רכישת כלים ומיומנויות נוספים",
  "q593": "הסכמה ותמיכה הדדית בין בני הזוג",
  "q594": "עזרה מגורם חיצוני",
  "q595": "גורל / מזל",
  "q596": "נסיבות חיצוניות",
  "q597": "אחר",
  "q60": "מאז ההצטרפות לתכנית, מה היה הדבר העיקרי שרציתם לשנות והצלחתם?",
  "q61": "מה עזר לכם להגיע להצלחה?",
  "q62": "מה הייתה ההתמודדות שלכם בהשגת המטרה הזו? (מה היו הקשיים שעליהם היו צריכים להתגבר?)",
  "q63": "ביסוס רשת תמיכה (רגשית/חברתית/כלכלית) של משפחה, חברים או שכנים",
  "q64": "מה עזר לכם לעשות את השינוי?",
  "q65": "סיום",
  "q66": "באיזו מידה התכנית ענתה על הציפיות שלכם?",
  "q67": "מה הייתם מציעים לשנות בתכנית?",
  "q68": "מידת השגת המטרות בתכנית עבודה",
  "q69": "חוות דעת",
  "q70": "חוות דעת מלווה/ת משפחה",
  "q71": "חוות דעת אשה",
  "q72": "חוות דעת גבר"
}
export const questionnareFields = microLegend
export class FamilyProgramQend extends Component {

    constructor(props) {
      super(props)
      this.state = { products: this.props.data }
      //this.onSaveTable = this.onSaveTable.bind(this)
      //this.handleProductTable = this.handleProductTable.bind(this)
      //console.log("QQ", this.props.data.bench_stat)
    }
    handleProductTableDate = (day, key)  => {
      var newp = Object.assign(this.state.products)
      newp[key] = day
      this.setState({products:newp})
    }
    handleProductTable = (evt) => {
        evt.preventDefault()
        var newp= updateElement(evt, this.state.products)
        this.setState({products:newp})
    }

    // update data base
    onSaveTable = (evt) => {
      evt.preventDefault()
      const { save2DB, subTableId, familyPostId, inUpdate, mbouser } = this.props
      // console.log("Family General save table: products", this.state.products)
      save2DB(familyPostId, this.state.products, subTableId, "group", inUpdate, mbouser )
    }
    render() {
      const {tableTitle} = this.props
      // const { data } = this.props
      // console.log("Family general data", data)
      // console.log("OLD meeting data", this.state.products)
      if (typeof this.props.data === "undefined"){
        // console.log("Parent Questionnair - props", this.props)
        return <h1>Internal Error: Missing data in this props data</h1>
      }
      return (
          <ProductTable 
            onProductTableUpdate={this.handleProductTable}
            onSaveTable={this.onSaveTable} 
            tableTitle = {tableTitle} 
            products={this.state.products} 
            onProductTableDate={this.handleProductTableDate}
          />
      )
    }
  }
   
  class ProductTable extends Component {
    constructor(props){
        super(props)
        this.state={
          filterText : "",
          detailedDisplay: false
      }
      //this.toggleDisplay = this.toggleDisplay.bind(this)
    }
    toggleDisplay = (evt) => {
      let tog = !this.state.detailedDisplay
      this.setState({detailedDisplay: tog})
     // console.log("toggleDisplay - now= ", tog ?"true":"false")
    }
    handleUserInput(filterText) {
        this.setState({filterText: filterText});
    }
    render() {
      const { onProductTableUpdate, products, tableTitle, onSaveTable, onProductTableDate } = this.props
      //console.log("General - products", products)
      const product = products
     
      const cellData=[{
        type: "text",
        name: "interviewer",
        value: product.interviewer,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "date",
        name: "date",
        value: product.date,
        id: product.id,
        style: {width: "100px"},
        placeholder: 'dd/mm/yyyy',
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: familyStatus, // ["משתתפת", "בהפסקה","נושרת", "מסיימת בהסכמה לפני המועד","בוגרת", "אחר"],
        name: "family_status",
        value: product.family_status,
        id: product.id,
        style: {width: "100px"},
        edit: true
      }, { // 4.1
        newsection: "הישגים ותכנית עבודה", // 3
        type: "textarea",
        name: "q60", 
        value: product.q60,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ // 4.2
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2five, // ["כלל לא-1", "2","3", "4","5"],
        name: "q2",
        value: product.q2,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },
      { // 4.3
        type: "textarea",
        name: "q61",
        value: product.q61,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ // 4.4
        type: "textarea",
        name: "q62",
        value: product.q62,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ // 4.5.1
        subsection: 'באיזו מידה אתם שבעי רצון מהשגת המטרות והיעדים בתכנית העבודה המשפחתית?',
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sevenB,
        name: "q70",
        value: product.q70,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ 
        type: "textarea",
        name: "q17",
        value: product.q17,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ // 4.5.2
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sevenB,
        name: "q71",
        value: product.q71,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ 
        type: "textarea",
        name: "q27",
        value: product.q27,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ // 4.5.3
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sevenB,
        name: "q72",
        value: product.q72,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ 
        type: "textarea",
        name: "q37",
        value: product.q37,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{ // 4.6
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,
        name: "q34",
        value: product.q34,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },

      { // 6.1
        newsection: 'צריכת שרותים',
        subsection: "האם כיום אתם משתמשים בשרותי הרווחה לצרכים הבאים?",
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q451",
        value: product.q451,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, //  ["לא", "כן"],
        name: "q452",
        value: product.q452,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q453",
        value: product.q453,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q454",
        value: product.q454,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q455",
        value: product.q455,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },
      
      {
        subsection: "האם מאז ההשתתפות בתכנית התחלתם להיעזר יותר באחד מהתחומים הבאים?",   // 5
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, //  ["לא", "כן"],
        name: "q461",
        value: product.q461,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q462",
        value: product.q462,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q463",
        value: product.q463,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q464",
        value: product.q464,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q465",
        value: product.q465,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q466",
        value: product.q466,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q467",
        value: product.q467,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes, // ["לא", "כן"],
        name: "q468",
        value: product.q468,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q469",
        value: product.q469,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q4610",
        value: product.q4610,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q4611",
        value: product.q4611,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect",
        options: noYes,  // ["לא", "כן"],
        name: "q4612",
        value: product.q4612,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q47",
        value: product.q47,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q48",
        value: product.q48,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2five, // ["כלל לא-1", "2","3", "4","5"],
        name: "q44",
        value: product.q44,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },
      
      { // 8.1
        newsection: 'תרומות התוכנית ומשוב', //7
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2five,
        name: "q51",
        value: product.q51,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },
      
      {
        type: "textarea",
        name: "q17",  // title only!
        value: product.q0,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },
      
      
      {
        subsection: "באיזו מידה אתם מרוצים מהסיוע של התכנית בתחומים הבאים?",
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q30',
        value: product.q30,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q31',
        value: product.q31,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q32',
        value: product.q32,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q33',
        value: product.q33,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q35',
        value: product.q35,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q36',
        value: product.q36,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q38',
        value: product.q38,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q39',
        value: product.q39,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q40',
        value: product.q40,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q41',
        value: product.q41,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q42',
        value: product.q42,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: 'q43',
        value: product.q43,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2sixTEXT,
        name: "q63",
        value: product.q63,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },

      
      {
        type: "textarea",
        name: "q64",
        value: product.q64,
        id: product.id,
        style: {width: "100px"},
        edit: true
      }, {
        subsection: 'סמן את התחומים שעזרו לשינוי',
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: onlyYes, // ["כן"],
        name: "q1",
        value: product.q1,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },
      {
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: onlyYes, // ["כן"],
        name: "q7",
        value: product.q7,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: onlyYes, // ["כן"],
        name: "q8",
        value: product.q8,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },    
      {
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: onlyYes, // ["כן"],
        name: "q5",
        value: product.q5,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: onlyYes, // ["כן"],
        name: "q6",
        value: product.q6,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },





     { subsection: 'באיזו מידה ענתה התכנית על הציפיות שלכם?',
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: one2five,
        name: "q50",
        value: product.q50,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q52",
        value: product.q52,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        newsection: "שאיפות וחלומות - אשה",
        type: "textarea",
        name: "q54",
        value: product.q54,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q55",
        value: product.q55,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        newsection: "סיווג התשובה",
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q561",
        value: product.q561,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q562",
        value: product.q562,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q563",
        value: product.q563,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q564",
        value: product.q564,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q565",
        value: product.q565,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "text",
        name: "q566",
        value: product.q566,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },{
        newsection: "שאיפות וחלומות - גבר",
        type: "textarea",
        name: "q57",
        value: product.q57,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "textarea",
        name: "q58",
        value: product.q58,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        newsection: "סיווג התשובה",
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q591",
        value: product.q591,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q592",
        value: product.q592,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q593",
        value: product.q593,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q594",
        value: product.q594,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q595",
        value: product.q595,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "radioSelect", // type: "select", ++++++++++++++++++++++++++++++++++++++++++++++++++++
        options: noYes,  // ["לא", "כן"],
        name: "q596",
        value: product.q596,
        id: product.id,
        style: {width: "100px"},
        edit: true
      },{
        type: "text",
        name: "q597",
        value: product.q597,
        id: product.id,
        style: {width: "400px"},
        edit: true
      },
      
      
      {
        newsection:"סיום",
        type: "textarea",
        name: "q67",
        value: product.q67,
        id: product.id,
        style: {width: "100px"},
        edit: true
      }] 

      return (
        <div className="yahav-modal">
            <h2 className="sub-tab-title">{tableTitle}</h2>
            
            <button type="button"  className="btn btn-success pull-left" onClick={onSaveTable}>עדכון</button>
            
            <div className="mynewdivform width1140 evenodd family-qend">
                <button type="button"  className="btn btn-success pull-left" 
                     onClick={this.toggleDisplay}>שינוי תצוגה</button>
                <ProductRow 
                    onProductTableUpdate={onProductTableUpdate} 
                    product={product} 
                    cd={cellData}
                    detailedDisplay = {this.state.detailedDisplay}
                    onProductTableDate = { onProductTableDate}
                    />
            </div>
        </div>
      )
    }
  }

class ProductRow extends React.PureComponent {
    
    render() {
      const {onProductTableUpdate, cd, detailedDisplay, onProductTableDate} = this.props
      var key = 0;
      return (
        <div className="eachRow">
          {cd.map(cellInfo => {
              return (
                <React.Fragment key={key++}>
                    {cellInfo.newsection !== undefined ? <h4 key={key++} >{cellInfo.newsection}</h4> : null }
                    {cellInfo.subsection !== undefined ? <h5 key={key++} >{cellInfo.subsection}</h5> : null }
                    <EditableFormCell key={key++} onProductTableUpdate={onProductTableUpdate} 
                        onProductTableDate={onProductTableDate}  cellData={cellInfo} detailedDisplay={detailedDisplay} />
                </React.Fragment>  
              )
          })}
        </div>
      )
    }
  }

  class EditableFormCell extends React.Component {
    handleChange = changeEvent => {
      this.setState({date: changeEvent.target.value})
    }
    render() {
        const tp = this.props
        const tpc = tp.cellData
        const detailedDisplay = tp.detailedDisplay

        const divStyleBblock = {padding: 0, verticalAlign: 'top', borderTop: 0, display: 'block', margin: '0 3px 5px 8px' }
        const labelStyle = {width: '45%', verticalAlign: 'top'}
        if (tpc.type === "date"){
          return (
             <div className="form-cell-box-inline">
               <label htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
               {<CalendarDay2
                   tpc = {tpc}
                   value = {tpc.value}
                   selected={new Date()}
                   onChange={this.handleChange}
                   handleChangeDate={tp.onProductTableDate} // {this.handleChangeDate}
               />}
             </div>
           )
        }
        if (tpc.type === "radioSelect" || tpc.type === "select"){
          if (detailedDisplay)
            tpc.type = "radioSelect"
          else
            tpc.type = "select"
        }
        if (tpc.type === "radioSelect")
          return (
            <div className="form-line" style={divStyleBblock}>
              {/* <span style={qnumStyle}>{qnum}</span> */}
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <RadioSelect value={tpc.value} options={tpc.options} onChange={tp.onProductTableUpdate} id={tpc.id} name={tpc.name} />
            </div>
          )
        if (tpc.type === "select"){
          return(
            <div className="form-line" style={divStyleBblock}>
              <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <SelectF tp={tp} tpc={tpc} overstyle={{ display: 'inline-block'}} />
            </div>
          )
        }
        if (tpc.type === "textarea"){
          return(
            <div className="form-line" style={divStyleBblock}>
              <label style={labelStyle}  htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
              <TextareaF tp={tp} tpc={tpc} overstyle={{ width:'40%'}} />
            </div>
          )
        }
        return (
            <div className="form-line" style={divStyleBblock}>
             <label style={labelStyle} htmlFor={tpc.id}>{microLegend[tpc.name]}</label>
             <InputF tp={tp} tpc={tpc} />
            </div>
        )
  
    }
  }

